import { useState, useRef, useEffect, MutableRefObject } from 'react';

interface UseIsStickyReturn {
  isSticky: boolean;
  stickyRef: MutableRefObject<HTMLDivElement | undefined>;
}
export const useIsSticky = (): UseIsStickyReturn => {
  // Observe if element is sticky
  const [isSticky, setIsSticky] = useState(false);
  const stickyRef = useRef<HTMLDivElement>();

  // mount
  useEffect(() => {
    const cachedRef: Element = stickyRef.current as unknown as Element;
    const observer = new IntersectionObserver(([e]) => setIsSticky(e.intersectionRatio < 1), {
      threshold: [1],
      rootMargin: '-1px 0px 0px 0px',
    });

    observer.observe(cachedRef);

    // unmount
    return () => {
      observer.unobserve(cachedRef);
    };
  }, []);

  return {
    isSticky,
    stickyRef,
  };
};
